<script lang="ts">
import { computed, defineComponent, reactive, toRefs } from 'vue'
import RightMenuItems from './RightMenuItems.vue'
import { Live360Icon, TryOnIcon } from '@/components'
import { useCustomization } from '@/hooks/useCustomization'
import { lenOptions } from '@/hooks/enums'
import { useEnhancer } from '@/app/enhancer'
import { useGtm } from '@/hooks/useGtm'
import { useDevices } from '@/hooks/useDevices'

export default defineComponent({
  name: 'ToolBar',
  components: { TryOnIcon, Live360Icon, RightMenuItems },
  props: {
    isBack: {
      type: Boolean,
      default: () => false,
    },
    modelValue: {
      type: Boolean,
      default: () => false,
      required: true,
    },
    contrastStyle: {
      type: String,
      default: () => '',
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { storeFavorites } = useEnhancer()
    const customization = useCustomization()
    const { pushGtm } = useGtm()
    const { isSmallMobile, isMobile } = useDevices()

    const trackingRefs = reactive({
      refTryOn: null as any,
      ref360: null as any,
    })

    const variantName = computed(() => storeFavorites.variantName)
    const variantLensOptions = computed(() => {
      const lensOptions = storeFavorites.selectedLenOption
      return lensOptions
        .filter(option => option !== lenOptions.NONE)
        .map((option) => {
          const item = customization.getLensOptions.value.find(
            item => item.key === option,
          )
          return item.label
        })
    })
    const variantPrice = computed(() => storeFavorites.variantPrice)
    const floatClassName = computed(() => {
      if (isMobile.value || isSmallMobile.value)
        return props.isBack ? 'z-vr disabled' : 'z-over-vr'
      return 'z-over-vr'
    })
    const isDemoMode = computed(() => customization.getCurrentDemoMode.value)
    const isShowSwitchMode = computed(
      () => customization.getCurrentSwitchMode.value,
    )
    // const isForceRefresh = computed(
    //   () => customization.getCurrentForceRefresh.value,
    // )

    const toggle = (value: boolean, relName: string) => {
      pushGtm(trackingRefs?.[relName]?.$el)
      // if (isForceRefresh.value)
      //   keepDefaultVariant(value)
      // else
      emit('update:modelValue', value)
    }

    return {
      ...toRefs(trackingRefs),
      toggle,
      variantName,
      isSmallMobile,
      variantLensOptions,
      variantPrice,
      isDemoMode,
      isShowSwitchMode,
      floatClassName,
    }
  },
})
</script>

<template>
  <section
    class="go-toolbar absolute full-width row  items-start" :class="[
      isShowSwitchMode ? 'justify-between' : 'justify-end',
    ]"
  >
    <!-- segment -->
    <div
      v-if="isShowSwitchMode"
      class="go-toolbar__segment bg-white q-btn--rounded q-mr-sm"
      :class="floatClassName"
    >
      <div
        class="row q-btn-group--rounded no-wrap q-btn-group--spread" :class="[
          { 'shadow-1': !modelValue },
        ]"
      >
        <q-btn
          ref="refTryOn"
          color="primary"
          :flat="!modelValue"
          class="q-py-none"
          rounded
          no-wrap
          glasson-click="menu_3d_tryon_switcher"
          @click="() => toggle(true, 'refTryOn')"
        >
          <TryOnIcon class="q-mr-xs" :class="[{ 'text-white': modelValue }]" />
          <span v-if="!isSmallMobile" class="text-caption">試着</span>
        </q-btn>
        <q-btn
          ref="ref360"
          color="primary"
          class="q-py-none"
          :flat="modelValue"
          rounded
          no-wrap
          glasson-click="menu_3d_tryon_switcher"
          @click="() => toggle(false, 'ref360')"
        >
          <Live360Icon class="q-mr-xs" :class="[{ 'text-white': !modelValue }]" />
          <span v-if="!isSmallMobile" class="text-caption">360°ビュー</span>
        </q-btn>
      </div>
    </div>
    <RightMenuItems
      :contrast-style="contrastStyle"
      :float-class-name="floatClassName"
      :is-try-on="modelValue"
    />
  </section>

  <section class="full-height column justify-between absolute" :class="isShowSwitchMode ? 'go-utils-switch' : 'go-utils'">
    <div class="text-shadow" :class="`text-${contrastStyle} ${floatClassName}`">
      <div class="text-caption text-weight-medium">
        {{ variantName }}
      </div>
      <!-- <div v-if="!isDemoMode" class="text-caption">{{ $filters.currency(variantPrice) }}(税込)</div> -->
      <span v-show="variantLensOptions.length">
        <div
          v-for="(item, index) in variantLensOptions"
          :key="index"
          class="text-caption"
        >
          {{ item }}
        </div>
      </span>
    </div>
  </section>
</template>
